import RatingItem from './RatingItem';
import React from 'react';

function RatingMouseOver(props) {
  return (
    <div className="ratings-mouseover normal-text">
      <div className="head-block font10">
        <div className="bold-text upper-case-text"> {props.t('RESULTS_PAGE.SCORE')} </div>{' '}
        <div className="upper-case-text nowrap font9"> {props.service.operator_details[2]} </div>{' '}
      </div>{' '}
      <div className="rating-items font9">
        {' '}
        {
          <RatingItem
            rating={
              props.service.operator_details[6] &&
              props.service.operator_details[6][
                Object.keys(
                  props.service.operator_details[6] && props.service.operator_details[6],
                )[0]
              ] &&
              props.service.operator_details[6][
                Object.keys(
                  props.service.operator_details[6] && props.service.operator_details[6],
                )[0]
              ].toFixed
                ? props.service.operator_details[6][
                    Object.keys(
                      props.service.operator_details[6] && props.service.operator_details[6],
                    )[0]
                  ].toFixed(1)
                : 0
            }
            label={props.t('RESULTS_PAGE.BUS_QUALITY')}
          />
        }{' '}
        {
          <RatingItem
            rating={
              props.service.operator_details[6] &&
              props.service.operator_details[6][
                Object.keys(
                  props.service.operator_details[6] && props.service.operator_details[6],
                )[1]
              ] &&
              props.service.operator_details[6][
                Object.keys(
                  props.service.operator_details[6] && props.service.operator_details[6],
                )[1]
              ].toFixed
                ? props.service.operator_details[6][
                    Object.keys(
                      props.service.operator_details[6] && props.service.operator_details[6],
                    )[1]
                  ].toFixed(1)
                : 0
            }
            label={props.t('RESULTS_PAGE.PUNCTUALITY')}
          />
        }{' '}
        {
          <RatingItem
            rating={
              props.service.operator_details[6] &&
              props.service.operator_details[6][
                Object.keys(
                  props.service.operator_details[6] && props.service.operator_details[6],
                )[2]
              ] &&
              props.service.operator_details[6][
                Object.keys(
                  props.service.operator_details[6] && props.service.operator_details[6],
                )[2]
              ].toFixed
                ? props.service.operator_details[6][
                    Object.keys(
                      props.service.operator_details[6] && props.service.operator_details[6],
                    )[2]
                  ].toFixed(1)
                : 0
            }
            label={props.t('RESULTS_PAGE.SERVICE_QUALITY')}
          />
        }{' '}
        {
          <RatingItem
            rating={
              props.service.operator_details[6] &&
              props.service.operator_details[6][
                Object.keys(
                  props.service.operator_details[6] && props.service.operator_details[6],
                )[3]
              ] &&
              props.service.operator_details[6][
                Object.keys(
                  props.service.operator_details[6] && props.service.operator_details[6],
                )[3]
              ].toFixed
                ? props.service.operator_details[6][
                    Object.keys(
                      props.service.operator_details[6] && props.service.operator_details[6],
                    )[3]
                  ].toFixed(1)
                : 0
            }
            label={props.t('RESULTS_PAGE.SERVICE_RECOMMENDATION')}
          />
        }{' '}
      </div>{' '}
      <div className="footer-block font9">
        {props.t('RESULTS_PAGE.RESULTS_CALCULATION') +
          Object.values(props.service.operator_details)[5] +
          props.t('RESULTS_PAGE.RESULTS_CALCULATION_USERS')}
      </div>{' '}
    </div>
  );
}

export default RatingMouseOver;



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/ServiceItem/components/RatingMouseOver.js